import ModalView from './modal-view.js'

const defaultOptions = {
  onOpen: null,
  onClose: null
}

const Plugin = {
  install (Vue, options = {}) {
    options = Object.assign({}, defaultOptions, options)

    if (this.installed) {
      return
    }

    this.installed = true
    this.event = new Vue()

    var containers = {}
    var components = {}
    options.modals.forEach(modal => {
      if (modal.name && modal.component) {
        var containerName = modal.container || 'default'
        containers[modal.name] = containerName

        components[modal.name] = modal.component
      }
    })

    Vue.prototype.$modal = {
      containers,
      options,
      open (name, params = {}) {
        Plugin.event.$emit('open-modal', name, params)
        this.activeModal = name
      },
      close () {
        Plugin.event.$emit('close-modal')
        this.activeModal = null
      }
    }

    Vue.component('modal-view', ModalView.extend({
      components: components,
      data () {
        return {
          containers: containers
        }
      }
    }))
  }
}

export default Plugin



// WEBPACK FOOTER //
// ./src/plugins/modal/index.js